import {charcoal} from '../sass/base/_exports.sass';

export const DownloadIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <path
        d="M27 24H5.667v-4H3v4a2.67 2.67 0 0 0 2.667 2.667H27A2.67 2.67 0 0 0 29.667 24v-4H27v4ZM14.61 3v11.448L8.884 8.724 7 10.609l8.943 8.943 8.942-8.943L23 8.724l-5.724 5.724V3h-2.667Z"
        fill={color}
      />
    </svg>
  );
};
